import { IFormConfigurationContext } from '@wyz/types';
import { createContext } from 'react';
import {
  IRimOptionItem,
  ITyreCountOptionItem,
  IVehicleTypeGroupsOptionItem,
} from '~/common/types';
import { IActiveVehicleTypeGroupReturnType } from '~/purchase/hooks';

export type IFormContext = {
  mode: IFormConfigurationContext['mode'];
  vehicleTypeGroups: IActiveVehicleTypeGroupReturnType & {
    optionItems: Array<IVehicleTypeGroupsOptionItem>;
  };
  rims: { optionItems: Array<IRimOptionItem> };
  tyreCounts: { optionItems: Array<ITyreCountOptionItem> };
};
export const FormContext = createContext<IFormContext | undefined>(undefined);
